var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var AuthActions = require('../../../modules/auth/actions/auth-register');
var authFacebookActions = require('../../../modules/auth/actions/auth-facebook');
var authRedirectUrlActions = require('../../../modules/auth/actions/auth-redirect-url');
var registerClickActions = require( '../../../modules/meta/actions/register-click');
var Register = require('../components/register.jsx');

var mapStateToProps = function(state){
  return {
    auth: state.auth
  };
};

var mapDispatchToProps = function(dispatch) {
	return bindActionCreators(Object.assign({}, AuthActions, authFacebookActions, authRedirectUrlActions, registerClickActions), dispatch);
}

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Register);



// WEBPACK FOOTER //
// ./src/common/routes/register/containers/register.jsx